import {EventBus} from "../utils/event-bus";
import {addToCart} from "../utils/gaTracking";
import {mapState} from "vuex";

const app = async () => {
    const { initialise } = await import(/* webpackChunkName: "bootstrap" */ '../bootstrap');
    const { default: baseSetup } = await import(/* webpackChunkName: "bootstrap" */ '../mixins/baseSetup');
    const { createStore } = await import(/* webpackChunkName: "store" */ "../store/store.js");

    const { Vue } = await initialise();
    const store = await createStore(Vue);

    const app = new Vue({
        el: "#app",
        name: "Product",
        mixins: [
            baseSetup,
        ],
        data: () => ({
           product: window.product,
            purchasableId: window.defaultVariantId,
            addingToCart: false,
            addedToCart: false,
            qty: 1,
        }),
        store,
        methods: {
            formatCurrency(value) {
                var formatter = new Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "GBP",
                    minimumFractionDigits: 2
                });
                return formatter.format(value);
            },
            async addToCart(e) {
                const formData = new FormData(e.target)
                let data = {}
                for (const [key, value] of formData.entries()) {
                    data[key] = value;
                }
                this.addingToCart = true;
                const res = await this.$store.dispatch('updateCart', data)

                if (res.error) {
                    alert(res.error);
                } else {
                    EventBus.$emit('open-cart-drawer');
                    addToCart(
                        this.purchasableId,
                        this.product.title,
                        (this.product.categories.lvl3 ?? this.product.categories.lvl2 ?? this.product.categories.lvl1 ?? this.product.categories.lvl0)[0],
                        this.qty,
                        this.product.price
                    )
                }
                this.addingToCart = false;
            },
            getActivePriceAsCurrency(multiplier = 1) {
                return this.formatCurrency(this.activePrice * multiplier)
            }
        },
        computed: {
            purchasable() {
                return this.product.variants.find(p => p.id === this.purchasableId);
            },
            isTradePrice() {
                if (this.user && this.user.tradePriceGroup) {
                    const tradePrice = this.purchasable.trade.find(item => item.group === this.user.tradePriceGroup);
                    if (tradePrice && tradePrice.price) return true;
                }
                return false;
            },
            activePrice() {
                if (this.user && this.user.tradePriceGroup) {
                    const tradePrice = this.purchasable.trade.find(item => item.group === this.user.tradePriceGroup);
                    if (tradePrice && tradePrice.price) return tradePrice.price;
                }
                return this.purchasable.salePrice;
            },
            ...mapState({
                user: state => state.user
            })
        },
        components: {
            "product-form": () => import(/* webpackChunkName: "productComponents" */"../components/ProductForm"),
            "product-stock": () => import(/* webpackChunkName: "productComponents" */"../components/ProductStock"),
            "product-images": () => import(/* webpackChunkName: "productComponents" */"../components/ProductImage"),
            "product-listing": () => import(/* webpackChunkName: "product-listing" */"../components/ProductListing"),
            "quantity-selector": () => import(/* webpackChunkName: "quantity-selector" */"../components/QuantitySelector"),
            "product-variant-selector": () => import(/* webpackChunkName: "variant-selector" */"../components/ProductVariantSelector"),
            "product-delivery-countdown": () => import(/* webpackChunkName: "product-delivery-countdown" */"../components/ProductDeliveryCountdown"),
            "back-in-stock": () => import(/* webpackChunkName: "product-delivery-countdown" */"../components/BackInStock"),
        }
    });
    return app;
}

app().then((vm) => {});




